export const mutations = {
  setFormData: function (state, newVal) {
    state.formData = { ...state.formData, ...newVal };
  },
  setToken: function (state, token) {
    state.access_Token = token;
  },
  SET_LOGGED_IN(state, value) {
    state.loggedIn = value;
  },
};
